import {doppeActionTypeDefineViewerMetadata} from '../../../client-server-common/doppe-action-types/doppe-action-type';
import React from 'react';
import {doppeActionTypeTwitterEmbed} from '../doppe-action-type-twitter-embed';

export const doppeActionTypeTwitterEmbedViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeTwitterEmbed, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeTwitterEmbedWidget: (await import(
                '../doppe-action-type-twitter-embed-widget/doppe-action-type-twitter-embed-widget'
                )).DoppeActionTypeTwitterEmbedWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeTwitterEmbedWidget
        } = viewerComponents

        return (
            <DoppeActionTypeTwitterEmbedWidget
                {...renderProps}
            />
        )
    },

    activateCTA: actionContext => {
        actionContext.navigateToUrl(actionContext.action.settings.twitterUrl, true);
    }

    // getActionButtonProps: (actionContext, observableActionContext) => {
    //     return {
    //         onClick: () => {
    //             actionContext.reportGoalAchieved();
    //
    //             actionContext.modalsController.showInnerModal({
    //                 content: ({modalController}) => ({
    //                     render: () => (
    //                         <DoppeViewerModalPanel
    //                             className={style(classes.modal, FlexLayout.column.default)}
    //                             mobileLayout={DoppeViewerModalPanelLayout.FullScreen}
    //                             desktopLayout={DoppeViewerModalPanelLayout.InnerCentered}
    //                         >
    //                             <DoppeViewerModalPanelHeader
    //                                 title={actionContext.action.name}
    //                                 dismissButtonCallback={() => {
    //                                     modalController.closeWindow();
    //                                 }}
    //                             />
    //                             <DoppeActionTypeTwitterEmbedWidget
    //                                 className={style(classes.widget, {}, FlexLayout.fillRemainingVerticalSpace)}
    //                                 actionContext={observableActionContext.getValue()}
    //                             />
    //                         </DoppeViewerModalPanel>
    //                     ),
    //                     dependencies: [observableActionContext]
    //                 })
    //             })
    //         }
    //     }
    // }
})